/* eslint-disable eslint-comments/disable-enable-pair, react/jsx-handler-names */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import 'src/components/Search/FormSend.scss';


const FormSend = ({ analyticsActions }) => {
  const searchButtonText = 'Szukaj';
  return (
    <Fragment>
      <button
        data-test="form-submit"
        onClick={ analyticsActions.sendSearchClick }
        styleName="form-send__element"
        type="submit"
      >
        <i className="mdi mdi-magnify" styleName="form-send__element-icon" />
        {' '}
        {searchButtonText}
        <span styleName="form-send__element-ripple" />
      </button>
    </Fragment>
  );
};

FormSend.propTypes = {
  analyticsActions: PropTypes.shape({
    sendSearchClick: PropTypes.func
  })
};

FormSend.defaultProps = {
  analyticsActions: {
    sendSearchClick: () => {}
  }
};


export default FormSend;
